// extracted by mini-css-extract-plugin
export default {"price":"h9-z","onSale":"i9-z","msrpLabelPrice":"j9-z","msrpLabel":"k9-z","originalPrice":"l9-z","percentOff":"m9-z"};